import { createObservableOperation } from 'owa-observable-operation';
import fetchSections from '../services/fetchSections';
import type { Place } from 'owa-graph-schema';
import type { TraceErrorObject } from 'owa-analytics-types';

const dest = createObservableOperation(
    'PLACES_ANALYTICS_LOAD_SECTIONS_FOR_FLOOR',
    (
        floorId: string,
        refetch: any = false
    ): {
        floorId: string;
        refetch: any;
    } => ({
        floorId,
        refetch,
    }),
    ({ floorId }) => floorId,
    ({ floorId, refetch }) => fetchSections(floorId, refetch)
);

const loadSections: (
    floorId: string,
    refetch?: any
) => {
    floorId: string;
    refetch: any;
} = dest.start;
const loadSectionsInProgress: (key: string) => boolean = dest.isInProgress;
const getSectionsLastError: (key: string) => TraceErrorObject | undefined = dest.getLastError;
const loadSectionsSucceeded: (
    actionMessage: {
        floorId: string;
        refetch: any;
    } & {
        result: Place[];
    }
) => {
    floorId: string;
    refetch: any;
} & {
    result: Place[];
} = dest.onSucceeded;

export { getSectionsLastError, loadSections, loadSectionsInProgress, loadSectionsSucceeded };
